"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactTracking = require("react-tracking");
var _iconApple = _interopRequireDefault(require("../../icons/icon-apple.svg"));
var _iconFacebook = _interopRequireDefault(require("../../icons/icon-facebook.svg"));
var _iconGoogle = _interopRequireDefault(require("../../icons/icon-google.svg"));
var _iconLine = _interopRequireDefault(require("../../icons/icon-line.png"));
var _languageDirectionAPI = require("../../services/languageDirectionAPI");
const StyledSocialButton = _styled.default.button(_ref => {
  let {
    theme,
    hasText
  } = _ref;
  return {
    alignItems: 'center',
    backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.white,
    border: `1px solid ${theme === null || theme === void 0 ? void 0 : theme.colors.grey[400]}`,
    borderRadius: '29px',
    color: theme === null || theme === void 0 ? void 0 : theme.colors.textPrimary,
    display: 'flex',
    fontSize: theme === null || theme === void 0 ? void 0 : theme.fontSizes.xxSmall,
    fontWeight: theme === null || theme === void 0 ? void 0 : theme.fontWeights.semiBold,
    height: hasText ? '44px' : '58px',
    width: hasText ? 'initial' : '58px',
    '&:hover': {
      cursor: 'pointer'
    },
    '& span': {
      marginTop: '2px'
    }
  };
});
const StyledButtonText = _styled.default.div(_ref2 => {
  let {
    direction,
    theme
  } = _ref2;
  return {
    fontWeight: theme === null || theme === void 0 ? void 0 : theme.fontWeights.medium,
    margin: 'auto',
    [direction === 'ltr' ? 'paddingRight' : 'paddingLeft']: '24px' // Balance out the icon so that the text is centered.
  };
});
const StyledSocialIcon = _styled.default.img(_ref3 => {
  let {
    direction,
    hasText
  } = _ref3;
  return {
    height: '22px',
    justifyContent: hasText ? 'left' : 'initial',
    marginLeft: hasText ? direction === 'ltr' && '10px' : 'auto',
    marginRight: hasText ? direction !== 'ltr' && '10px' : 'auto'
  };
});
const socialIcons = {
  apple: {
    icon: _iconApple.default
  },
  facebook: {
    icon: _iconFacebook.default
  },
  google: {
    icon: _iconGoogle.default
  },
  line: {
    icon: _iconLine.default
  }
};

/**
 * A [Button component](/story/elements-button--default) that is used only for social oauth logins. Has a variant for each supported social service.
 */
const SocialButton = _ref4 => {
  let {
    children,
    onClick,
    provider
  } = _ref4;
  const {
    trackEvent
  } = (0, _reactTracking.useTracking)();
  const {
    direction
  } = (0, _languageDirectionAPI.useLanguageDirection)();
  const handleClick = () => {
    trackEvent({
      event_name: `${provider}-button`,
      event_type: 'click'
    });
    onClick();
  };
  return /*#__PURE__*/_react.default.createElement(StyledSocialButton, {
    hasText: !!children,
    id: `${provider}-auth-button`,
    type: "button",
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(StyledSocialIcon, {
    alt: `${provider} icon`,
    direction: direction,
    hasText: !!children,
    src: socialIcons[provider].icon
  }), children && /*#__PURE__*/_react.default.createElement(StyledButtonText, {
    direction: direction
  }, children));
};
var _default = exports.default = SocialButton;